import LogoSvg from "../../../../assets/images/logo.svg";

const Logo = () => (
  <img
    style={{ width: "107px", height: "20px" }}
    src={LogoSvg}
    alt="PS Lifestyle"
  />
);

export default Logo;
